import Swal from "sweetalert2";
import i18n from "../i18n";
import { GetPackageDetailByTracking, PatchShippingFee } from "api/packages";
import { GetRouteDetail } from "api/routes";
import { getScanText, playReadyBeebSound, playYahooSound } from "utils";

// The Scan page asks for the service fee at a sort station when a COD / Fanshine /
// sub-customer parcel still has a 0 fee. Scans triggered from Unassigned Packages and
// Match Package skip that page, so they call this first. Resolves true when the parcel
// is OK to scan (no fee needed, or fee saved) and false when staff cancelled the prompt
// or saving failed — the parcel then stays unscanned. Mirrors scenes/scan/index.jsx.
export async function ensureShippingFee(tracking, station) {
  if (!station?.isSortStation) return true;

  const pkgRes = await GetPackageDetailByTracking(getScanText(tracking));
  // Let the scan itself report a missing/invalid parcel.
  if (!pkgRes || pkgRes.status !== 200) return true;
  const pkg = pkgRes.data;

  let routeData = null;
  if (pkg.routeId && pkg.routeId !== "N/A") {
    const routeRes = await GetRouteDetail(pkg.routeId);
    if (routeRes?.status === 200) routeData = routeRes.data;
  }

  const needsFee =
    (pkg.isCOD || routeData?.isFanshine || pkg.isSubCustomer) &&
    parseInt(pkg.shippingFee) === 0;
  if (!needsFee) return true;

  if (routeData?.isFanshine || parseInt(pkg.customer?.level) > 1) {
    playYahooSound(); // special customers / agents that get a discount
  } else {
    playReadyBeebSound(); // normal customers
  }

  const t = (key) => i18n.t(`scan.shippingFeePrompt.${key}`);
  const result = await Swal.fire({
    title: t("title"),
    text: `${pkg.customer?.name} - ${pkg.customer?.whatsapp}`,
    input: "number",
    inputAttributes: {
      style:
        "display: block; margin: 20px auto; text-align: center; width: 150px; height: 50px; padding: 10px; font-size: 30px;",
    },
    showCancelButton: true,
    inputValidator: (value) => {
      if (!value) return t("required");
      if (isNaN(value)) return t("invalid");
      if (value <= 0) return t("mustBePositive");
    },
  });
  if (!result.isConfirmed) return false;

  const res = await PatchShippingFee(
    pkg._id,
    pkg.tracking,
    pkg.orderId,
    pkg.description,
    pkg.remark,
    pkg.amount,
    pkg.quantity,
    result.value
  );
  if (res && res.success) return true;

  Swal.fire({ title: "Error!", icon: "error", text: t("updateFailed"), showConfirmButton: true });
  return false;
}
